import React from "react";
import PublicNavBar from "../public_header/NarBar";
import { useLayoutSidebarStore } from "../../store/layout/useLayoutSidebarStore";

interface PublicLayoutProps {
  children: React.ReactNode;
}

const PublicLayout: React.FC<PublicLayoutProps> = ({ children }) => {
  const { sidebarOpen, setSidebarOpen } = useLayoutSidebarStore();

  return (
    <div className="bg-main min-h-screen overflow-x-hidden">
      <PublicNavBar sidebarOpen={sidebarOpen} setSidebarOpen={setSidebarOpen} />
      <div className="flex-1 p-4 overflow-x-hidden">
        {children}
      </div>
    </div>
  );
};

export default PublicLayout;
